import { withClassName } from 'lp-hoc'

const Card = withClassName('card')('div')

export default Card
